import { Ty } from '../../ty';
import { Assert } from '../../utils';
import { EraQlAst } from '../eraql-ast/ast';
import { withNullMeta } from '../lex/types';
import { fromAssoc, fromCallOf } from './helpers';

export const tyToEraQlAst = (input: Ty.Shorthand): EraQlAst => {
  const { nullable, tags, ty } = Ty.ty(input);

  let output: EraQlAst;

  switch (ty.k) {
    case 'primitive':
      output = { t: 'symbol', sym: ty.t };
      break;
    case 'array':
      output = fromCallOf('ARRAY', [tyToEraQlAst(ty.t)], 'fc');
      break;
    case 'enum':
      output = fromCallOf('ENUM', ty.t, 'fc');
      break;
    case 'range':
      output = fromCallOf('RANGE', [ty.start, ty.end], 'fc');
      break;
    case 'record':
      output = fromCallOf('RECORD', [tyToEraQlAst(ty.t)], 'fc');
      break;
    case 'struct':
      output = fromCallOf(
        'STRUCT',
        [fromAssoc(ty.fields, (ty) => tyToEraQlAst(ty))],
        'fc'
      );
      break;
    default:
      return Assert.unreachable(ty);
  }

  if (!nullable) {
    output = {
      t: 'call',
      args: [withNullMeta(output)],
      op: withNullMeta({ t: 'operator', op: '!' }),
      display: 'postfix',
    };
  }

  return tags.reduce(
    (curr, tag) => fromCallOf('TAG', [curr, tag], 'fc'),
    output
  );
};
